// this file is automatically generated by git.version.ts script
export const versions = {version: '2.0.0', revision: '8e9d18af7200f6758530c287cfa77bb7046d519d'};